// 图表配置 新增、编辑
<template>
  <div class="infoPage_box">
    <el-form
      :model="infoData"
      :rules="rules"
      ref="infoData"
      class="demo-ruleForm info_content_box"
    >
      <div class="form_item_box">
        <el-form-item label="视图名称" prop="name">
          <div class="input_box">
            <el-input v-model="infoData.name" placeholder="请输入" />
          </div>
        </el-form-item>
      </div>
      <div class="form_item_box">
        <el-form-item label="数据类型" prop="type">
          <div class="input_box">
            <el-select v-model="infoData.type" placeholder="请选择数据类型">
              <el-option label="sql" :value="1"> </el-option>
              <el-option label="api" :value="2"> </el-option>
            </el-select>
          </div>
        </el-form-item>
      </div>
      <div class="form_item_box" v-if="infoData.type === 1">
        <el-form-item label="数据源" prop="sourceId">
          <div class="input_box">
            <el-select v-model="infoData.sourceId" placeholder="请选择数据源">
              <el-option
                v-for="item in sourceArr"
                :key="item.id"
                :label="item.dbName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </el-form-item>
      </div>
      <!-- <el-form-item label="描述" prop="remark">
        <div class="input_box">
          <el-input v-model="infoData.remark" placeholder="请输入" />
        </div>
      </el-form-item> -->
      <el-form-item label="查询 SQL" prop="viewSql">
        <div class="input_box">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入内容"
            v-model="infoData.viewSql"
          />
        </div>
      </el-form-item>
      <div style="text-align: right">
        <el-button
          type="primary"
          @click="executeSql()"
          class="add_item_btn"
          size="mini"
          plain
        >
          SQL 解析
        </el-button>
      </div>

      <el-table
        :data="tableData"
        style="width: 100%"
        row-key="id"
        class="table_box drow_table"
      >
        <el-table-column
          v-for="(col, i) in tableHeader"
          :prop="col.prop"
          :key="i"
          :label="col.label"
          :width="col.width || ''"
          :align="col.align || 'center'"
        >
          <template slot="header">
            <p>
              {{ col.label }}
              <span style="color: red; font-size: 16px">*</span>
            </p>
          </template>

          <template slot-scope="scope">
            <!-- :rules="col.rulesName" -->
            <el-form-item>
              <!-- render 自定义组件 -->
              <ex-slot
                v-if="col.render"
                :render="col.render"
                :row="scope.row"
                :index="scope.$index"
                :column="col"
              >
              </ex-slot>
              <span v-else>{{ scope.row[col.prop] || "-" }}</span>
            </el-form-item>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <div class="dia_footer">
      <el-button type="primary" @click="onSave">确 认</el-button>
      <el-button @click="diaClose">取 消</el-button>
    </div>
  </div>
</template>

<script>
// 自定义内容的组件
var exSlot = {
  functional: true,
  props: {
    row: Object,
    render: Function,
    index: Number,
    column: {
      type: Object,
      default: null,
    },
  },
  render: (h, data) => {
    const params = {
      row: data.props.row,
      index: data.props.index,
    };
    if (data.props.column) params.column = data.props.column;
    return data.props.render(h, params);
  },
};
import Sortable from "sortablejs";
export default {
  //自定义组件
  components: {
    "ex-slot": exSlot,
  },
  props: {
    row: Object,
  },
  data() {
    return {
      infoData: {
        model: null,
        name: null,
        sourceId: null,
        type: null,
        viewSql: null,
      },
      rules: {},
      tableHeader: [
        {
          label: "字段名称",
          prop: "name",
        },
        {
          label: "字段类型",
          prop: "type",
        },
        {
          label: "纬度",
          prop: "modelType",
          render: (h, params) => {
            return (
              <el-select
                v-model={params.row.modelType}
                placeholder={"请选择"}
                clearable
              >
                <el-option label={"维度"} value={"category"}></el-option>
                <el-option label={"指标"} value={"value"}></el-option>
              </el-select>
            );
          },
        },
      ],
      tableData: [],
      sourceArr: [],
    };
  },

  created() {
    if (this.row.id) {
      this.infoData.id = this.row.id;
      this.getChartsViewInfo();
    }
  },
  mounted() {
    this.getDataSourceList();
  },
  methods: {
    async getChartsViewInfo() {
      const params = {
        id: this.infoData.id,
      };
      const { data } = await this.$api.getChartsViewInfo(params);
      // this.moduleArr = data;
      Object.keys(this.infoData).forEach((key) => {
        this.infoData[key] = data[key];
      });
      this.tableData = JSON.parse(data.model);
    },
    // 数据源信息选择列表
    async getDataSourceList() {
      const { data } = await this.$api.getDataSourceList();
      console.log("data", data);
      this.sourceArr = data;
    },
    // 执行SQL查询数据
    async executeSql() {
      if (!this.infoData.viewSql || !this.infoData.sourceId) return;
      const { data } = await this.$api.executeSql({
        sourceId: this.infoData.sourceId,
        sql: this.infoData.viewSql,
      });
      this.tableData = data;
    },

    onSave() {
      this.infoData.model = JSON.stringify(this.tableData);

      this.$refs["infoData"].validate((valid) => {
        if (valid) {
          if (this.infoData.id) {
            this.$emit("onUpdate", this.infoData);
          } else {
            this.$emit("onAdd", this.infoData);
          }
        } else {
          this.$message("请填写完整");
          return false;
        }
      });
    },

    diaClose() {
      this.$emit("diaClose");
    },
  },
};
</script>

<style lang="scss" scoped>
// .dia_box .input_item {
//   padding: 0;
// }

// .dia_box .input_item .input_item_value {
//   width: 300px;
// }

// .pwd {
//   text-security: disc;
//   -webkit-text-security: disc;
// }

.form_item_box {
  width: 300px;
}
.table_box {
  .el-form-item {
    margin-bottom: 0;
  }
}
.add_item_btn {
  margin-bottom: 10px;
}

.dia_footer {
  margin-top: 20px;
}
</style>
